import React, { useEffect, useState } from 'react'
import { compose } from 'recompose'
import { connect, useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Prompt } from 'react-router'
import { reduxForm, destroy } from 'redux-form'
import { Grid, Container, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { injectIntl, FormattedDate } from 'react-intl'
import {
	fetchSurvey,
	fetchSurveyNavigation,
	startSaving,
	stopSaving,
	showModal,
	getTeamBackground,
	getTeamLogo,
	getCase
} from '../../../redux/actions'
import * as cookies from '../../../utilties/cookies'
import { withRouter } from 'react-router'
import {
	surveySelector,
	questionListSelector,
	questionsSelector,
	questionHashSelector,
	surveyNavigationSelector,
	surveySavedSelector,
	caseSelector
} from '../../../redux/selectors'

import { submitSurvey } from '../../../redux/actions'
import SurveyBody from './SurveyBody'
import { Paper } from '@material-ui/core'
import { isSavingSelector } from '../../../redux/selectors'
import CalmButton from '../../../components/CalmButton'
import CompletedSurveyForm from './CompletedSurveyForm'
import history from '../../../utilties/history'
import RequiredQuestions from '../components/RequiredQuestions'

const useStyles = makeStyles((theme) => ({

	paperStyle: {
		padding: '0 32px 32px',
		[theme.breakpoints.down('sm')]: {
			padding: '0 15px 15px',
		},
	},
	formSurvey: {
		paddingTop: '32px',
		[theme.breakpoints.down('sm')]: {
			paddingTop: '15px',
		},		
	},

	titleName: {
		fontWeight: '400',
		fontSize: '28px',
		[theme.breakpoints.down('xs')]: {
			fontSize: '22px',
		},		
	},
	titleNameLabel: {
		fontWeight: '300',
		fontSize: '28px',
		[theme.breakpoints.down('xs')]: {
			fontSize: '22px',
		},
	}
}))

const scrollFirstErrorIntoView = () => {
	let firstError = document.querySelectorAll('.errorWrapper')[0]
	
	if(firstError) {
		let container = firstError.closest('.questionWrapper')
		if (container) {
			container.scrollIntoView()
		}
	}
}

const SurveyForm = ({
	intl,
	match,
	loadCase,
	loadTeamBackground,
	loadTeamLogo,
	loadSurvey,
	loadSurveyNavigation,
	handleSubmit,
	submitForm,
	questionList,
	questionCollection,
	questionHash,
	surveyNavigation,
    anyTouched,
	caseModel
}) => {
	const classes = useStyles()
	const [ patient ] = useState(cookies.get('user'))
	const dispatch = useDispatch()
	const [_instanceId, setInstanceId] = useState(null)
	const isSaving = useSelector(isSavingSelector, shallowEqual)
	const surveySaved = useSelector(surveySavedSelector, shallowEqual)
	const [clickedSaveSurvey, setClickedSaveSurvey] = useState(false)
	const [ bilateralAreaNames, setBilateralAreaNames ] = useState([])
	const [ lists, setLists ] = useState(null)
	const [ collections, setCollections ] = useState(null)
	const [ selectedAreaIndex, setSelectedAreaIndex ] = useState(0)
	const [ bilateralAreas, setBilateralAreas ] = useState(null)

	useEffect(
		() => {
			loadTeamBackground()
			loadTeamLogo()
		}, []
	)

	useEffect(
		() => {
			if (match.params.caseId && match.params.instanceId && match.params.surveyId) {
				dispatch(destroy('survey'))
				loadCase(patient.id, match.params.caseId)

				setInstanceId(match.params.instanceId)
				loadSurvey(match.params.instanceId, match.params.caseId, match.params.surveyId, patient.languageId ? patient.languageId : 1)
				loadSurveyNavigation(match.params.instanceId, match.params.caseId, match.params.surveyId, patient.languageId ? patient.languageId : 1)

				setLists(null)
				setCollections(null)
			}
		},
		[ match.params.caseId, match.params.protocolId, match.params.instanceId, match.params.surveyId ]
    )

    useEffect(() => {
		if (anyTouched)
        {
            window.onbeforeunload = () => intl.formatMessage({ id: 'app.unsavedChangesAlert.text' })
		} else
        {
            window.onbeforeunload = undefined
        }

        return () => window.onbeforeunload = undefined;
	}, [anyTouched])

	useEffect(
		() => {
			if (!caseModel) {
				return
			}

			let areas = [caseModel.area1Name]

			if (!!caseModel.area2Name) {
				areas.push(caseModel.area2Name)
			}

			setBilateralAreas(areas)
		},
		[ caseModel ]
	)

	useEffect(
		() => {
			if (
				!!bilateralAreas?.length
				&& !!questionList?.length
				&& !!questionCollection?.length
				&& !collections?.length
			) {
				let startIndex = !!caseModel.selectedAreaName
					? bilateralAreas.findIndex(x => x === caseModel.selectedAreaName)
					: 0

				setSelectedAreaIndex(startIndex)

				if (!!caseModel.selectedAreaName) {
					setBilateralAreaNames([ caseModel.selectedAreaName ])
				}
				else {
					setBilateralAreaNames(bilateralAreas)
				}

				let resultLists = questionList.filter((_, index) => index >= startIndex)
				let resultCollections = questionCollection.filter((_, index) => index >= startIndex)

				setLists(resultLists)
				setCollections(resultCollections)
			}
		},
		[ !!questionList && !!questionCollection, !!bilateralAreas ]
	)

	useEffect(
		() => {
			if (surveySaved) {
				loadSurveyNavigation(match.params.instanceId, match.params.caseId, match.params.surveyId, patient.languageId ? patient.languageId : 1)
			}
		},
		[surveySaved]
	)

	useEffect(
		() => {
			if (!surveyNavigation) {
				return
			}

			if (!!surveyNavigation.surveyIsCompleted) {
				if (
					!!surveyNavigation.nextCaseId
					&& !!surveyNavigation.nextProtocolId
					&& !!surveyNavigation.nextSurveyInstanceId
					&& !!surveyNavigation.nextSurveyId
				) {
					dispatch(
						showModal(
							CompletedSurveyForm,
							{
								openNextSurveyPage: handleOpenNextSurveyPage,
								disableBackdropClick: true
							},
							false
						)
					)
				}
				else {
					history.push("/")
				}
			}
			else {
				var orientationName = null
				switch (surveyNavigation.screenOrientation) {
					case 2:
						orientationName = 'portrait'
						break;
					case 3:
						orientationName = 'landscape'
						break;
					default:
						orientationName = 'any'
						break;
				}

				const params = new URLSearchParams({'orientation': orientationName })

				history.push({search: params.toString()})
			}
		},
		[surveyNavigation]
	)

	const handleOpenNextSurveyPage = (caseId, protocolId, surveyInstanceId, surveyId) => {
		history.push(`/survey/${caseId}/${protocolId}/${surveyInstanceId}/${surveyId}`)
		window.onbeforeunload = undefined
		window.location.reload(true)
	}

	const onSubmitForm = (values) => {
        setClickedSaveSurvey(true);

		var objs = !bilateralAreas.length ? [[]] : bilateralAreas.map(_ => [])

		const addQuestionAnswer = (side, id, questionType, isVisible, value) => {
			let obj = objs[side]

			let existsQuestion = obj.find((item) =>
				item.questionId == id
				&& item.questionType == questionType
			)
			if (
				!existsQuestion
				|| (
					!!existsQuestion
					&& !!value
				)
			) {
				obj.push({
					questionType: questionType,
					questionId: id,
					answer: isVisible ? value : null
				})
			}
		}

        var fileInputs = document.getElementsByClassName('file-question');

        Array.prototype.forEach.call(fileInputs, function (i) {
            let uniqueId = i.getAttribute('data-questionId');
            let side = i.getAttribute('data-column');

			let hash = questionHash[side]

			let node = hash[uniqueId]

			let q = node.data;
			let changed = i.getAttribute('data-changed') == 'true';

			let isVisible = false
			collections[side].map((node) => {
				if (node.data.uniqueId == uniqueId) {
					isVisible = node.data.isVisible
					return true
				}
				else {
					return false
				}
			})

			let duplicate = (
				isVisible
				&& !q.isBilateral
				&& bilateralAreas.length > 1
			)

			if ((!!isVisible || !changed) && !!i.value) {
				const obj = {
            	    questionType: q.questionType,
            	    questionId: q.id,
            	    answer: (changed ? i.getAttribute('data-fileKey') : null),
            	    fileLength: (changed ? parseInt(i.getAttribute('data-fileLength')) : null),
            	    fileName: (changed ? i.getAttribute('data-fileName') : null),
            	    mimeType: (changed ? i.getAttribute('data-mime') : null),
            	    notChanged: !changed
            	}

            	objs[parseInt(side)].push(obj)

				if (duplicate) {
					objs[parseInt(1)].push({...obj})
				}
        	}
		}); 

		if (values && values.answers) {
			dispatch(startSaving())
			Object.keys(values.answers).map(function(answerKey, index) {
				Object.keys(values.answers[answerKey]).map(function(subAnswersKey) {
					let subAnswers = values.answers[answerKey][subAnswersKey]

					let uniqueId = subAnswersKey.replace('_', '')

					Object.keys(subAnswers).map(subAnswerKey => {
						let subAnswer = subAnswers[subAnswerKey]

						let side = parseInt(subAnswerKey.replace('_', ''))

						let isVisible = false
						questionCollection
							.map((collection, collectionIndex) => {
								collection
									.map((node) => {
										if (node.data.uniqueId == uniqueId) {
											if (!!node.data.isVisible) {
												isVisible = true
											}
	
											if (
												!isVisible
												&& !node.data.changed
												&& !node.data.parentChanged
												&& node.data.questionType != 10
												&& node.data.questionType != 11
											) {
												switch (node.data.questionType) {
													case 1: case 2:
														node.data.answers.map((answer) => {
															if (!!answer.checked) {
																addQuestionAnswer(
																	collectionIndex,
																	node.data.id,
																	node.data.questionType,
																	true,
																	answer.id
																)
															}
														})
														break
													case 3:
														node.data.categories.map((category) => {
															if (!!category.value) {
																addQuestionAnswer(
																	collectionIndex,
																	category.id,
																	node.data.questionType,
																	true,
																	category.value
																)
															}
														})
														break
													default:
														if (!!node.data.value) {
															addQuestionAnswer(
																collectionIndex,
																node.data.id,
																node.data.questionType,
																true,
																node.data.value
															)
														}
														break
												}
											}
										}
									})
							})

						let q = questionHash[0][uniqueId].data

						let duplicate = (
							isVisible
							&& !q.isBilateral
							&& bilateralAreas.length > 1
						)
			
						if (
							q.questionType == 2 //Multiple
						) {
							if (subAnswer) {
								Object.keys(subAnswer).map((el, i) => {
									var multipleUniqueId = subAnswer[el]
	
									let qFromSide = questionHash[side][uniqueId].data
									addQuestionAnswer(
										side,
										q.id,
										q.questionType,
										qFromSide.isVisible,
										multipleUniqueId
									)

									if (duplicate) {
										addQuestionAnswer(
											side == 0 ? 1 : 0,
											q.id,
											q.questionType,
											qFromSide.isVisible,
											multipleUniqueId
										)
									}
								})
							}
						} else if (
							q.questionType == 3 //Grouped
						) {
							if (subAnswer) {
								Object
								.keys(subAnswer)
								.map((el, i) => {
									var multipleUniqueId = side

									const groupSide = parseInt(el.replace('_', ''))

									let qFromSide = questionHash[groupSide][uniqueId].data
									addQuestionAnswer(
										groupSide,
										multipleUniqueId,
										q.questionType,
										qFromSide.isVisible,
										subAnswer[el]
									)

									if (duplicate) {
										addQuestionAnswer(
											groupSide == 0 ? 1 : 0,
											multipleUniqueId,
											q.questionType,
											qFromSide.isVisible,
											subAnswer[el]
										)
									}
								})
							}
						}
						else if (
							q.questionType == 10 ||
							q.questionType == 11 // File
						) { }
						else {
							let currentSide = side + selectedAreaIndex

							let qFromSide = questionHash[currentSide][uniqueId].data
							addQuestionAnswer(
								currentSide,
								q.id,
								q.questionType,
								qFromSide.isVisible,
								subAnswer
							)

							if (duplicate) {
								addQuestionAnswer(
									currentSide == 0 ? 1 : 0,
									q.id,
									q.questionType,
									qFromSide.isVisible,
									subAnswer
								)
							}
						}
					})
				})
			})
			
			if(!objs[0].some(x => x.answer || x.answer === 0))
			{
				dispatch({
					type: 'SET_SNACKBAR_MESSAGE',
					data: {
						message: 'app.survey.noAnswersError',
						isSuccess: false
					}
				})
				dispatch(stopSaving())
			} else {
				submitForm(match.params.caseId, match.params.protocolId, match.params.instanceId, match.params.surveyId, objs)
			}
		}
		else {
			dispatch({
				type: 'SET_SNACKBAR_MESSAGE',
				data: {
					message: 'app.survey.noAnswersError',
					isSuccess: false
				}
			})
		}

	}
	return (
		<Container className="survey-form-page" maxWidth="lg" style={{ marginTop: '3em' }}>
            <Prompt
				when={anyTouched && !clickedSaveSurvey}
                message={intl.formatMessage({ id: 'app.unsavedChangesAlert.text' })} />
			<Grid
				container
				spacing={3}
			>
				<Grid item className="survey-form-wrapper" xs={12} sm={11} style={{ margin: '0 auto 40px' }}>
					<Paper className={classes.paperStyle} square={true} elevation={3}>
						<form 
							className={classes.formSurvey}  
							data-testid="form-survey" 
							onSubmit={handleSubmit(onSubmitForm)}
						>
							{
								!!surveyNavigation
								&& <Grid
									container
									alignContent="left"
									direction="column"
									spacing={1}
									style={{										
										paddingBottom: '20px'
									}}
								>
									<Grid item>
										<span
											className={classes.titleNameLabel}
											data-testid="survey-name-label"
											style={{  }}
										>
											{intl.formatMessage({ id: 'app.survey.surveyNameLabel' })}
										</span>
										<span
											className={classes.titleName}
											data-testid="survey-name"
											variant='h2'
										>
											{surveyNavigation.surveyTitle}
										</span>
									</Grid>
									<Grid item>
										<span
											className={classes.titleNameLabel}
											data-testid="protocol-name-label"
										>
											{intl.formatMessage({ id: 'app.survey.protocolNameLabel' })}
										</span>
										<span
											className={classes.titleName}
											data-testid="protocol-name"
										>
											{surveyNavigation.protocolName}
										</span>
									</Grid>
									<Grid item>
										<span
											className={classes.titleNameLabel}
											data-testid="due-date-label"
										>
											{intl.formatMessage({ id: 'app.survey.dueLabel' })}
										</span>
										<span
											className={classes.titleName}
											data-testid="due-date"
										>
											<FormattedDate
												value={surveyNavigation.dueDate + 'Z'}
												year='numeric'
												month='short'
												day='2-digit'
												timeZone="UTC"
											/>
										</span>
									</Grid>
								</Grid>
							}

							{/* <Grid item>{survey && <SurveyHeader survey={survey} />}</Grid> */}
							<Grid item>
								<SurveyBody
									data-testid="form-survey-body"
									instanceId={_instanceId}
									isBilateral={caseModel?.isBilateral}
									bilateralAreas={bilateralAreaNames}
									lists={lists}
									collections={collections}
								/>
							</Grid>

							<Grid item style={{ textAlign: 'center', padding: '64px 0 32px' }}>
								{!isSaving && <CalmButton
									data-testid="form-survey-button"
									variant='contained'
									color='primary'
									size='large'
									type='submit'
									disabled={isSaving}
								>
									{intl.formatMessage({ id: 'app.dashboard.saveButton' })}
								</CalmButton>}
								{isSaving && (
									<Grid data-testid="progress" item style={{ textAlign: 'center', paddingTop: '16px' }}>
										<CircularProgress />
									</Grid>
								)}
							</Grid>
						</form>
					</Paper>
				</Grid>
			</Grid>
		</Container>

	)
}

const mapStateToProps = (state, ownProps) => ({
	survey: surveySelector(state),
	questionList: questionListSelector(state),
	questionCollection: questionsSelector(state),
	questionHash: questionHashSelector(state),
	surveyNavigation: surveyNavigationSelector(state),
	caseModel: caseSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	loadCase: (patientId, caseId) => dispatch(getCase(patientId, caseId)),
	loadTeamBackground: () => dispatch(getTeamBackground()),
	loadTeamLogo: () => dispatch(getTeamLogo()),
	loadSurvey: (observationProtocolSurveyId, circleId, surveyId, languageId) => dispatch(fetchSurvey(observationProtocolSurveyId, circleId, surveyId, languageId)),
	loadSurveyNavigation: (
		observationProtocolSurveyId,
		circleId,
		surveyId,
		languageId
	) => dispatch(
		fetchSurveyNavigation(
			observationProtocolSurveyId,
			circleId,
			surveyId,
			languageId
		)
	),
	submitForm: (caseId, protocolId, instanceId, surveyId, questionAnswers) =>
		dispatch(submitSurvey(caseId, protocolId, instanceId, surveyId, questionAnswers))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: 'survey',
		touchOnChange: true,
        touchOnBlur: true,
		onSubmitFail: async (errors, dispatch, submitError, questionList) => {
			setTimeout(() => scrollFirstErrorIntoView(), 500)

			let details = '';
			if (errors && errors.answers)
            {
				var message = '';
				//get just first unanswered question
				var questionErrorType = Object.keys(errors.answers)[0] 
				var questionErrors = Object.values(errors.answers)[0]
				var questionUniqueId = Object.keys(questionErrors)[0]
				var questionErrorObj = Object.values(questionErrors)[0];
				var groupedQuestionGroupId = '';
				var questionAreaId = Object.keys(questionErrorObj)[0]

				if (questionErrorType == 'grouped')
				{
					groupedQuestionGroupId = Object.keys(questionErrorObj)[0]
					var groupedQuestionErrorObj = Object.values(questionErrorObj)[0]
					questionAreaId = Object.keys(groupedQuestionErrorObj)[0]
				}
				
				questionList.survey.answeredQuestions[questionAreaId.replace('_', '')].questions.forEach((question) => {
					if (question.uniqueId == questionUniqueId.replace('_', ''))
					{
						message += question.title
						if (questionErrorType == 'grouped')
						{
							question.categories.forEach((category) => {
								if (category.id == groupedQuestionGroupId.replace('_', ''))
								{
									message += ' - ' + category.label
								}
							})
						}
						message += '\n'
					}
				})

				dispatch(
					showModal(
						RequiredQuestions,
						{
							message: message
						},
						true
					)
				)	

                details = JSON.stringify(errors.answers);
            }
			else if (submitError) {
				details = "Unexpected JS error: ";
				if (submitError.message) {
					details += `${submitError.message} Stack: ${submitError.stack}`;
				}
				else {
					details += "Unknown error";
				}
			}
			
			await fetch(`/api/utility/log/validation`, {
				method: 'post',
				headers: { 
					'Content-Type': 'text/plain', 
					'utility-log-location': window.location.href 
				},
				body: details
			})
        }
	}),
	withRouter
)

export default enhance(SurveyForm)
